import HotelBookingDashboard from "../Dashboard/Dashboard";

interface IHotelDashboardProps {
  tableMaxHeight: number;
}

const HotelDashboard = (props: IHotelDashboardProps): JSX.Element => {
  const { tableMaxHeight } = props;
  return <HotelBookingDashboard tableMaxHeight={tableMaxHeight} />;
};

export default HotelDashboard;
